import React, { useContext, useState } from 'react';
import * as styles from './index.module.less';
import Switch from '@/components/switch';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Paragraph } from '@/components';
import { PricingContext } from '../provider';

interface IProps {
  className?: string;
}

const SwitchPayType = ({ className = '' }: IProps) => {
  const { t } = useTranslation();
  const { dispatchFormInfo } = useContext(PricingContext);
  const [isYearPay, setIsYearPay] = useState(true);

  const msgData = {
    month: t('subscribe_pay_type_Monthly'),
    year: t('subscribe_pay_type_Annually'),
  };

  const handleSwitch = (isChecked) => {
    if (isChecked) {
      dispatchFormInfo({
        type: 'payType',
        value: 'year',
      });
    } else {
      dispatchFormInfo({
        type: 'payType',
        value: 'month',
      });
    }
    setIsYearPay(isChecked);
  };

  return (
    <div className={`${styles.wrapper} ${className}`}>
      <div className={styles.inner}>
        <Paragraph style={isYearPay ? {} : { color: '#3164FF' }}>{msgData.month}</Paragraph>
        <Switch defaultValue={true} sliderColor="#3164FF" sliderClass={styles.switch_slider} onChange={handleSwitch} />
        <Paragraph style={isYearPay ? { color: '#3164FF' } : {}}>{msgData.year}</Paragraph>
      </div>
    </div>
  );
};
export default SwitchPayType;
